export default "__VITE_ASSET__BANgjbKb__"